import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useEffect, useState } from "react";
import useDebounce from "../../hooks/useDebounce";
import { MenuItem, Select } from "@mui/material";

const JumpPagePagination = ({
  offset,
  setOffset,
  setOffsetMemory,
  limit,
  setLimit,
  total,
  canChangeLimit,
}) => {
  const [pageOffset, setPageOffset] = useState(offset);
  const debounce = useDebounce(pageOffset, 1000);

  useEffect(() => {
    if (setOffset && offset !== pageOffset)
      setOffset(pageOffset === 0 ? 1 : pageOffset);
    if (setOffsetMemory && offset !== pageOffset)
      setOffsetMemory(limit, pageOffset === 0 ? 1 : pageOffset);
  }, [debounce]);

  return (
    <div className="w-full flex end text-[12px] text-[#2C3E5D]">
      <div
        className={`flex gap-2 items-center text-right w-full ${
          canChangeLimit ? "justify-between" : "justify-end"
        }`}
      >
        {canChangeLimit ? (
          <div className="flex gap-2 items-center w-full">
            <p>Rows per page</p>
            <Select
              value={limit}
              onChange={(e) => {
                setLimit(e.target.value);
                if (setOffset) setOffset(1);
              }}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={25}>25</MenuItem>
              <MenuItem value={50}>50</MenuItem>
            </Select>
            <p className="italic">
              Showing {(offset - 1) * limit + 1}-
              {total < offset * limit ? total : offset * limit} of {total}{" "}
              Entries
            </p>
          </div>
        ) : null}
        <button
          type="button"
          disabled={offset === 1}
          onClick={() =>
            setOffsetMemory ? setOffsetMemory(limit, 1) : setOffset(1)
          }
          className="disabled:text-gray-300"
        >
          Awal
        </button>
        <button
          type="button"
          disabled={offset === 1}
          className="rounded-md p-2 w-[36px] h-[36px] border-gray-300 cursor-pointer hover:bg-gray-100 disabled:bg-gray-300 disabled:cursor-default disabled:text-gray-300 bg-white"
          onClick={() =>
            setOffsetMemory
              ? setOffsetMemory(limit, offset - 1)
              : setOffset(offset - 1)
          }
        >
          <FaChevronLeft className="w-full h-full" />
        </button>

        {(Math.ceil(total / limit) < 3
          ? Array.from({ length: Math.ceil(total / limit) }, (_, i) => i + 1)
          : offset + 2 < Math.ceil(total / limit)
          ? [offset, offset + 1, offset + 2]
          : [
              Math.ceil(total / limit) - 2,
              Math.ceil(total / limit) - 1,
              Math.ceil(total / limit),
            ]
        ).map((item, i) => {
          return (
            <button
              type="button"
              disabled={offset === item}
              className={`rounded-md p-2 w-[36px] h-[36px] border-gray-300 cursor-pointer hover:bg-gray-100 disabled:bg-[#071B82] ${
                offset === item ? "bg-[#071B82]" : "bg-white"
              } disabled:cursor-default disabled:text-white`}
              onClick={() =>
                setOffsetMemory ? setOffsetMemory(limit, item) : setOffset(item)
              }
            >
              {item}
            </button>
          );
        })}
        <button
          type="button"
          disabled={offset === Math.ceil(total / limit)}
          className="rounded-md p-2 w-[36px] h-[36px] border-gray-300 cursor-pointer hover:bg-gray-100 disabled:bg-gray-300 disabled:cursor-default disabled:text-gray-300 bg-white"
          onClick={() =>
            setOffsetMemory
              ? setOffsetMemory(limit, offset + 1)
              : setOffset(offset + 1)
          }
        >
          <FaChevronRight className="w-full h-full" />
        </button>
        <button
          type="button"
          disabled={offset === Math.ceil(total / limit)}
          onClick={() =>
            setOffsetMemory
              ? setOffsetMemory(limit, Math.ceil(total / limit))
              : setOffset(Math.ceil(total / limit))
          }
          className="disabled:text-gray-300"
        >
          Akhir
        </button>
      </div>
    </div>
  );
};

export default JumpPagePagination;
